import React from 'react'
import {
  useProductFunctions,
  useProductState,
  useConfigState,
  useLocalLabels,
} from '@sentecacommerce-theme/lib'
import { ProductPageLabels } from '../../productPage.props'
import styled from 'styled-components'
import { BasketButton, Typography, IconShop } from '../../../Common'

export const AddToBasket = ({
  containerRef,
  onClick,
}: {
  containerRef?:
    | ((instance: HTMLDivElement | null) => void)
    | React.RefObject<HTMLDivElement>
    | null
  onClick?: () => void
}) => {
  const { getCustomFieldValue } = useProductFunctions()
  const { selectedVariant, metaData } = useProductState()
  const config = useConfigState()
  const offerId = selectedVariant?.offer?._id as string
  const isOnlyInPhysicalStores = getCustomFieldValue(
    config.customFieldKeys.isOnlyInPhysicalStores
  )
  const labels = useLocalLabels<ProductPageLabels>()
  return (
    <Container ref={containerRef}>
      <ButtonsContainer>
        {!isOnlyInPhysicalStores ? (
          <>
            <BasketButton
              productId={metaData._id as string}
              variantId={selectedVariant?._id as string}
              offerId={offerId as string}
              maxQuantity={Math.min(
                selectedVariant?.quantity || 0,
                selectedVariant?.offer?.maxQuantity ||
                  config.inventory.maxQuantity
              )}
              selectedOptions={selectedVariant?.selectedOptions || []}
              type="normal"
              onClick={onClick}
              canOrder={selectedVariant?.inventory?.hasAvailableQuantity}
            />
          </>
        ) : (
          <Label>
            <StyledIconShop />
            {labels?.availableOnlyInPhysicalStores}
          </Label>
        )}
      </ButtonsContainer>
    </Container>
  )
}

const ButtonsContainer = styled.div.attrs({
  className: 'd-flex align-items-center justify-content-between',
})``

const Container = styled.div.attrs({
  className: 'px-3',
})`
  width: 100%;
`

const Label = styled(Typography).attrs({
  variant: '8',
  color: 'burntSienna',
  className: 'd-flex align-items-center',
})<any>`
  line-height: 1;
  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    font-size: 1.4rem;
  }
`
const StyledIconShop = styled(IconShop).attrs({ className: '' })`
  width: 3rem;
  height: 3rem;
  margin-right: 1.3rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    width: 3rem;
    height: 3rem;
  }
`
